export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/Worker.6116add7.worker.js");
}
